import styled from 'styled-components'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const Navbar = styled.nav.attrs((props) => composeTheme(props))`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: ${(props) => props.theme.navbar.height};
  background-color: ${(props) => props.theme.navbar.backgroundColor};
  padding: ${(props) => props.theme.navbar.padding};
  border-bottom: ${(props) => props.theme.navbar.border};
  width: 100%;
  z-index: 500;

  div {
    margin-right: auto;
  }
`

export const Menu = styled.ul.attrs((props) => composeTheme(props))`
  display: flex;
  align-items: center;
  padding: 0;
  height: 100%;
  margin: 0;
  z-index: inherit;
  margin-right: ${(props) => props.theme.navbar.marginRight};
`

export const CentralizedContent = styled.div`
  width: 100%;
`

export const ContainerLogo = styled.div.attrs((props) => composeTheme(props))`
  margin-left: ${(props) => props.theme.navbar.marginLeft};
`

export const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
`
ContainerLogo.defaultProps = defaultTheme
Menu.defaultProps = defaultTheme
Navbar.defaultProps = defaultTheme

//used in stories
export const ContainerMenuItem = styled.div`
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 10px;
  display: flex;
`

export const ProfilePicture = styled.div`
  align-items: center;
  background: #fb7414;
  border-radius: 50%;
  border: 2px solid #eaecf0;
  cursor: pointer;
  display: flex;
  height: 4rem !important;
  text-align: center;
  transition: 0.8s;
  width: 4rem !important;

  span {
    color: #fff;
    font-weight: 700;
    width: -webkit-fill-available;
    width: -moz-available;
  }

  &:hover {
    background: #c43f0a;
  }
`

export const SubmenuContainer = styled.div`
  font-family: 'Inter';
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`
export const AccountMenu = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #eaecf0;
`

export const Logout = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
  color: #344054;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  span {
    margin-left: 12px;
  }
`
